import Prensa from '../2026/Prensa';
import Valores from '../pages/valores/Valores';
import VillaMaria from '../pages/villamaria/VillaMaria';
import Fotos from '../pages/fotos/Fotos';
import EnVivo from '../pages/enVivo/EnVivo';
import Home from '../2026/Home';
import Recorrido from '../2026/Recorrido';
import RecorridoContador from '../2026/RecorridoContador';
import CertamenValores from '../2026/CertamenValores';

const routes = [
    { path: '/', element: <Home />, title: "Festival de peñas", sidebar: true, },
    // { path: '/en-vivo', element: <EnVivo />, title: "En vivo", sidebar: true },
    // { path: '/recorrido', element: <Recorrido />, title: "Recorrido peñero", sidebar: true },
    { path: '/recorrido', element: <RecorridoContador />, title: "Recorrido", sidebar: true },
    { path: '/recorrido-mapa', element: <Recorrido />, title: "Recorrido Mapa", sidebar: false },
    { path: '/villa-maria', element: <VillaMaria />, title: "Villa María", sidebar: true },
    { path: '/nuevos-valores', element: <CertamenValores />, title: "Certamen Nuevos valores", sidebar: true },
    { path: '/prensa', element: <Prensa />, title: "Prensa", sidebar: true },
    // { path: '/nuevos-valores-old', element: <Valores />, title: "Certamen Nuevos valores Old", sidebar: false },
];

export default routes;